if (!customElements.get("draggable-scroll")) {
  class DraggableScroll extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      window.addEventListener("load", () => {
        this.classList.add('loaded');
  
        this.swiperContainer = this.querySelector(".td-collection-header-links");
        this.swiperScrollbar = this.querySelector(".td-collection-header-scrollbar");
        if (!this.swiperContainer || !this.swiperScrollbar) {return}
        const swiper = new Swiper(this.swiperContainer, {
          grabCursor: true,
          slidesPerView: 'auto',
          autoHeight: true,
          spaceBetween: 12,
          freeMode: true,
          loop: false,
          scrollbar: {
            el: this.swiperScrollbar,
            draggable: true,
            dragSize: 'auto',
            hide: false
          }
        });
      });
    }
  }
  
  customElements.define('draggable-scroll', DraggableScroll);
}